import { IncomeTypesLogic, Translations } from "@salaxy/core";

import { InputController } from "./InputController";

/**
 * Controller behind form controls that selects Income type code for transaction in Income Registry (Tulorekisteri).
 */

export class InputIncomeTypeController extends InputController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["SessionService", "UiHelpers"];

  /** Type of the input element. Default is typeahead. */
  public type: "typehead" | "list";

  /**
   * List of income type codes to exclude from the selection list.
   */
  public hiddenCodes: number[];

  /**
   * Creates a new InputIncomeTypeController
   * @ignore
   */
  constructor() {
    super();
  }

  /** Sets the default values in init. */
  public $onInit() {
    super.$onInit();
    if (!this.type) {
      this.type = "typehead";
    }
  }

  /** Gets the list of all income types. */
  public getIncomeTypes = (searchString: string) => {
    IncomeTypesLogic.getAll();
    let result = IncomeTypesLogic.search(searchString);

    if (this.hiddenCodes) {
      result = result.filter(x => !this.hiddenCodes.includes(x.code));
    }

    return result.map(incomeType => ({
      value: incomeType.code,
      text: incomeType.label,
      title: incomeType.description,
      ui: {
        initials: incomeType.code,
        color: "#2b507c",
        entityType: "company"
      }
    }));
  };

  /**
   * Returns the label for given income type.
   * @param code - Income type code.
   */
  public getRowLabel(code: string): string {
    if (!code) {
      return null;
    }
    const type = IncomeTypesLogic.getAll().find((x) => x.code === Number(code));
    return type ? (type.code + " - " + type.label) : "SALAXY.NG1.InputIncomeType.getRowLabelNotFound" + code;
  }

  /** Returns the placeholder text - this control has a default text. */
  public getPlaceholder() {
    return super.getPlaceholder() || Translations.get("SALAXY.NG1.InputIncomeType.getPlaceholder");
  }
}
